import axiosUrl from './axios.service';
import axios from 'axios';
import store from '../store/index';
import authHeader from '../helpers/auth-header';
import moment from 'moment';
import AuthService from '../services/auth.service';
import router from '../router';
import { computed } from 'vue';

const API_URL = axiosUrl.getAxiosUrl();
const isTableView = computed({
  get: () => store.state.newsSearch.isTableView,
});
class NewsService {
  async loadDefaultNews() {
    return await axios
      .get(API_URL + '/search/searchnews', {
        headers: authHeader(),
        params: {
          PageSize: isTableView.value ? 25 : 10,
          Page: 0,
          Sort: 'Nieuwste',
        },
      })
      .then((response) => {
        store.commit('newsSearch/updateCurrentPage', 1);
        store.commit('news/updateSearchResults', response.data);
        store.commit('newsSearch/updatePageCount', response.data.pageCount + 1);
        store.commit(
          'newsSearch/updateResultsCount',
          response.data.resultCount
        );
        store.commit('news/updateAllNews', response.data);
        store.commit('news/disableIsNewsPageLoading');
      })
      .catch((error) => {
        if (error.response.status === 401 || error.response.status === 403) {
          // auto logout if 401 or 403 response returned from api
          AuthService.logout();
          router.go();
        }
      });
  }

  async getSearchResults(
    searchText,
    dateFrom,
    dateTo,
    audienceTags,
    schemesTags,
    projectTypes,
    locationsTags,
    purposesTags,
    //This is just hidden for now, don't remove it:
    //industriesTags,
    orgsIncludeString,
    orgsExcludeString,
    selectedSort,
    page
  ) {
    return await axios
      .get(API_URL + '/search/searchnews', {
        headers: authHeader(),
        params: {
          Term: searchText.value,
          PageSize: 10,
          Page: page != null && page.value != null ? page.value - 1 : 0,
          DateFrom:
            dateFrom.value != null && dateFrom.value != ''
              ? moment(dateFrom.value, 'DD-MM-YYYY').format('YYYY-MM-DD')
              : null,
          DateTo:
            dateTo.value != null && dateTo.value != ''
              ? moment(dateTo.value, 'DD-MM-YYYY').format('YYYY-MM-DD')
              : null,
          AudienceTags: audienceTags.value,
          PurposesTags: purposesTags.value,
          SchemeTypesTags: schemesTags.value,
          ProjectTypesTags: projectTypes.value,
          LocationsTags: locationsTags.value,
          //This is just hidden for now, don't remove it
          //IndustriesTags: industriesTags.value,
          NotOrganisations:
            orgsExcludeString.value.length > 0 ? orgsExcludeString.value : null,
          Organisations:
            orgsIncludeString.value.length > 0 ? orgsIncludeString.value : null,
          Sort: selectedSort.value,
        },
      })
      .then((response) => {
        store.commit(
          'newsSearch/updateCurrentPage',
          page != null && page.value != null ? page.value - 1 : 0
        );
        store.commit('news/updateSearchResults', response.data);
        store.commit('newsSearch/updatePageCount', response.data.pageCount + 1);
        store.commit(
          'newsSearch/updateResultsCount',
          response.data.resultCount
        );
        store.commit('news/updateAllNews', response.data);
        store.commit('news/disableIsNewsPageLoading');
      })
      .catch((error) => {
        console.log(error);
        if (error.response.status === 401 || error.response.status === 403) {
          // auto logout if 401 or 403 response returned from api
          AuthService.logout();
          router.go();
        }
      });
  }

  async getResulstsByPage(
    current,
    searchText,
    dateFrom,
    dateTo,
    audienceTags,
    schemesTags,
    projectTypes,
    locationsTags,
    purposesTags,
    //This is just hidden for now, don't remove it:
    //industriesTags,
    orgsIncludeString,
    orgsExcludeString,
    selectedSort
  ) {
    return await axios
      .get(API_URL + '/search/searchnews', {
        headers: authHeader(),
        params: {
          Term: searchText.value,
          PageSize: isTableView.value ? 25 : 10,
          Page: current,
          DateFrom:
            dateFrom.value != null && dateFrom.value != ''
              ? moment(dateFrom.value, 'DD-MM-YYYY').format('YYYY-MM-DD')
              : null,
          DateTo:
            dateTo.value != null && dateFrom.value != ''
              ? moment(dateTo.value, 'DD-MM-YYYY').format('YYYY-MM-DD')
              : null,
          AudienceTags: audienceTags.value,
          PurposesTags: purposesTags.value,
          SchemeTypesTags: schemesTags.value,
          ProjectTypesTags: projectTypes.value,
          LocationsTags: locationsTags.value,
          //This is just hidden for now, don't remove it
          //IndustriesTags: industriesTags.value,
          NotOrganisations:
            orgsExcludeString.value.length > 0 ? orgsExcludeString.value : null,
          Organisations:
            orgsIncludeString.value.length > 0 ? orgsIncludeString.value : null,
          Sort: selectedSort.value,
        },
      })
      .then((response) => {
        store.commit('news/updateSearchResults', response.data);
        store.commit('newsSearch/updatePageCount', response.data.pageCount + 1);
        store.commit(
          'newsSearch/updateResultsCount',
          response.data.resultCount
        );
        store.commit('news/updateAllNews', response.data);
        store.commit('news/disableIsNewsPageLoading');
      })
      .catch((error) => {
        if (error.response.status === 401 || error.response.status === 403) {
          // auto logout if 401 or 403 response returned from api
          AuthService.logout();
          router.go();
        }
      });
  }

  async getResulstsByPageTable(
    current,
    searchText,
    dateFrom,
    dateTo,
    audienceTags,
    purposesTags,
    schemesTags,
    projectTypes,
    locationsTags,
    //This is just hidden for now, don't remove it:
    //industriesTags,
    orgsIncludeString,
    orgsExcludeString,
    selectedSort
  ) {
    return await axios
      .get(API_URL + '/search/searchnews', {
        headers: authHeader(),
        params: {
          Term: searchText.value,
          PageSize: 25,
          Page: current,
          DateFrom:
            dateFrom.value != null && dateFrom.value != ''
              ? moment(dateFrom.value, 'DD-MM-YYYY').format('YYYY-MM-DD')
              : null,
          DateTo:
            dateTo.value != null && dateFrom.value != ''
              ? moment(dateTo.value, 'DD-MM-YYYY').format('YYYY-MM-DD')
              : null,
          AudienceTags: audienceTags.value,
          PurposesTags: purposesTags.value,
          SchemeTypesTags: schemesTags.value,
          ProjectTypesTags: projectTypes.value,
          LocationsTags: locationsTags.value,
          //This is just hidden for now, don't remove it
          //IndustriesTags: industriesTags.value,
          NotOrganisations:
            orgsExcludeString.value.length > 0 ? orgsExcludeString.value : null,
          Organisations:
            orgsIncludeString.value.length > 0 ? orgsIncludeString.value : null,
          Sort: selectedSort.value,
        },
      })
      .then((response) => {
        store.commit('news/updateSearchResults', response.data);
        store.commit('newsSearch/updatePageCount', response.data.pageCount + 1);
        store.commit(
          'newsSearch/updateResultsCount',
          response.data.resultCount
        );
        store.commit('news/updateAllNews', response.data);
        store.commit('news/disableIsNewsPageLoading');
      })
      .catch((error) => {
        if (error.response.status === 401 || error.response.status === 403) {
          // auto logout if 401 or 403 response returned from api
          AuthService.logout();
          router.go();
        }
      });
  }

  async getSearchResultsTable(
    searchText,
    dateFrom,
    dateTo,
    audienceTags,
    schemesTags,
    projectTypes,
    locationsTags,
    purposesTags,
    //This is just hidden for now, don't remove it:
    //industriesTags,
    orgsIncludeString,
    orgsExcludeString,
    selectedSort,
    page
  ) {
    return await axios
      .get(API_URL + '/search/searchnews', {
        headers: authHeader(),
        params: {
          Term: searchText.value,
          PageSize: 25,
          Page: page.value - 1,
          DateFrom:
            dateFrom.value != null && dateFrom.value != ''
              ? moment(dateFrom.value, 'DD-MM-YYYY').format('YYYY-MM-DD')
              : null,
          DateTo:
            dateTo.value != null && dateTo.value != ''
              ? moment(dateTo.value, 'DD-MM-YYYY').format('YYYY-MM-DD')
              : null,
          AudienceTags: audienceTags.value,
          PurposesTags: purposesTags.value,
          SchemeTypesTags: schemesTags.value,
          ProjectTypesTags: projectTypes.value,
          LocationsTags: locationsTags.value,
          //This is just hidden for now, don't remove it
          //IndustriesTags: industriesTags.value,
          NotOrganisations:
            orgsExcludeString.value.length > 0 ? orgsExcludeString.value : null,
          Organisations:
            orgsIncludeString.value.length > 0 ? orgsIncludeString.value : null,
          Sort: selectedSort.value,
        },
      })
      .then((response) => {
        store.commit('newsSearch/updateCurrentPage', page.value);
        store.commit('news/updateSearchResults', response.data);
        store.commit('newsSearch/updatePageCount', response.data.pageCount + 1);
        store.commit(
          'newsSearch/updateResultsCount',
          response.data.resultCount
        );
        store.commit('news/updateAllNews', response.data);
        store.commit('news/disableIsNewsPageLoading');
      })
      .catch((error) => {
        if (error.response.status === 401 || error.response.status === 403) {
          // auto logout if 401 or 403 response returned from api
          AuthService.logout();
          router.go();
        }
      });
  }

  async getNewsById(id, statisticType) {
    return await axios
      .get(API_URL + '/news/getNewsById', {
        params: {
          newsId: id,
          statisticType: statisticType
        },
        headers: authHeader(),
      })
      .then((response) => {
        store.commit('news/updateSelectedNews', response.data);
        store.commit('news/disableNewsDetailsLoading');
      })
      .catch((error) => {
        if (error.response.status === 401 || error.response.status === 403) {
          // auto logout if 401 or 403 response returned from api
          AuthService.logout();
          router.go();
        }
      });
  }

  async searchLatestNews(page, size) {
    return await axios
      .get(API_URL + '/search/searchnews', {
        headers: authHeader(),
        params: {
          PageSize: size,
          Page: page,
          Sort: 'Nieuwste',
        },
      })
      .then((response) => {
        if (page > 0) {
          store.commit('homePageItems/updateLatestNews', response.data);
        } else {
          store.commit('news/updateLatestNews', response.data);
          store.commit('homePageItems/updateLatestNews', response.data);
        }
      })
      .catch((error) => {
        if (error.response.status === 401 || error.response.status === 403) {
          // auto logout if 401 or 403 response returned from api
          AuthService.logout();
          router.go();
        }
      });
  }

  async searchLatestNewsWithTags(page, size, audiences, purposes, locations) {
    return await axios
      .get(API_URL + '/search/searchnews', {
        headers: authHeader(),
        params: {
          PageSize: size,
          Page: page,
          Sort: 'Nieuwste',
          AudienceTags: audiences.length > 0 ? audiences : null,
          PurposesTags: purposes.length > 0 ? purposes : null,
          LocationsTags: locations.length > 0 ? locations : null,
        },
      })
      .then((response) => {
        if (page > 0) {
          store.commit('homePageItems/updateLatestNews', response.data);
        } else {
          store.commit('news/updateLatestNews', response.data);
          store.commit('homePageItems/updateLatestNews', response.data);
        }
      })
      .catch((error) => {
        if (error.response.status === 401 || error.response.status === 403) {
          // auto logout if 401 or 403 response returned from api
          AuthService.logout();
          router.go();
        }
      });
  }
}

export default new NewsService();
